import { render, staticRenderFns } from "./installIpa.vue?vue&type=template&id=5511f152"
import script from "./installIpa.vue?vue&type=script&lang=js"
export * from "./installIpa.vue?vue&type=script&lang=js"
import style0 from "./installIpa.vue?vue&type=style&index=0&id=5511f152&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports